import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useLandingsList(workspaceId: string | undefined) {
  return useQuery({
    queryKey: ["landings-list", workspaceId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("landings")
        .select("*")
        .eq("workspace_id", workspaceId!)
        .order("created_at", { ascending: false });
      if (error) throw error;
      return data;
    },
    enabled: !!workspaceId,
    staleTime: 2 * 60 * 1000,
  });
}
